import { useCallback } from 'react';
import gql from 'graphql-tag';
import { useConversationNav_Rh_GetConversationByIdQuery, useRh_GetSyndicationUrlsQuery } from '../types/GraphqlTypes';
import { isHotpads, isZillow } from '@zg-rentals/multibrand-support';
import type { Brand } from '@zg-rentals/multibrand-support';

const isTrulia = (value: unknown): value is 'trulia' => value === 'trulia';

export default () => {
  const useConversationNavRhGetConversationByIdDocumentQuery = useCallback(
    ({ conversationId }: { conversationId: string | undefined }) => {
      const { data, loading, error } = useConversationNav_Rh_GetConversationByIdQuery({
        variables: {
          conversationId: conversationId || '',
        },
        fetchPolicy: 'cache-first',
        skip: !conversationId,
      });
      return { data, loading, error };
    },
    [],
  );

  const useRHGetSyndicationUrlsQuery = useCallback(
    ({ listingAlias, brand }: { listingAlias: string | undefined; brand: Brand }) => {
      const { data, loading, error } = useRh_GetSyndicationUrlsQuery({
        variables: {
          listingAlias: listingAlias!,
          fetchZillow: isZillow(brand),
          fetchHotpads: isHotpads(brand),
          fetchTrulia: isTrulia(brand),
        },
        skip: !listingAlias,
      });
      return { data, loading, error };
    },
    [],
  );

  return {
    useConversationNavRhGetConversationByIdDocumentQuery,
    useRHGetSyndicationUrlsQuery,
  };
};

// prettier-ignore
export const GET_SYNDICATION_URLS = gql`
    query RH_getSyndicationUrls(
        $listingAlias: String!
        $fetchZillow: Boolean!
        $fetchHotpads: Boolean!
        $fetchTrulia: Boolean!
    ) {
        RH_getSyndicationUrls(listingAlias: $listingAlias) {
            hotpadsUrl @include(if: $fetchHotpads)
            zillowUrl @include(if: $fetchZillow)
            truliaUrl @include(if: $fetchTrulia)
        }
    }
`;
